import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../logo.png'
import { useGlobalContext } from '../context'

export default function Navbar() {
  const { setLoading } = useGlobalContext();
  const { setTimer } = useGlobalContext();
  return (
    <nav className='container navbar-container mr-auto ml-auto navbar bg-dark  rounded'>
      <div className='navbar-brand'>
        <Link to='/'>
          <img src={logo}  alt='Trivia Quiz' className='logo' />
        </Link>
        </div>
      <div className='navbar-nav mr-auto'>
        <li className='pl-5 navbar-item'>
          <Link to='/' onClick={() => { setLoading(true); setTimer(false) } } className='btn btn-light'>Home</Link>
        </li>
        </div>
    </nav>
  )
}
